var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',[_c('a-col',{attrs:{"md":4}}),_c('a-col',{attrs:{"md":16}},[_vm._t("default")],2),_c('a-col',{attrs:{"md":4}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }